import * as React from 'react';
import get from 'lodash/get';
import { Avatar } from '@material-ui/core';
import { FieldProps } from 'react-admin';
import { UserModel } from "model/user/schema";

interface AvatarFieldProps extends FieldProps<UserModel> {
    className?: string;
    size?: number;
}

export const AvatarField = (props: AvatarFieldProps) => {
    const { record, source, size = 25, className } = props;
    const sourceValue = source !== undefined ? get(record, source) : undefined;

    return (
        <Avatar
            src={sourceValue}
            style={{ width: size, height: size }}
            className={className}
        />
    );
}